











import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
  },
});
